// Version : 0.0.5
// Author : ARAVINDHAN
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET ALL PURPOSE OF LOAN TYPE DETAILS START *********************** */
export const getPurposeOfLoanTypeList = (Data: any) => {
	const data = {
		PurposeOfLoanTypeListToken: Data,
	};
	const url = `${API_URL}getPurposeOfLoanType`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL PURPOSE OF LOAN TYPE DETAILS END *********************** */

/** ***************** ADD PURPOSE OF LOAN TYPE DETAILS START *********************** */
export const addPurposeOfLoanType = (Data: any) => {
	const data = {
		PurposeOfLoanTypeCreateToken: Data,
	};
	const url = `${API_URL}addPurposeOfLoanType`;
	return makeApiCall(url, data);
};
/** ***************** ADD PURPOSE OF LOAN TYPE DETAILS END *********************** */

/** ***************** DELETE PURPOSE OF LOAN TYPE DETAILS START *********************** */
export const purposeofLoanTypeDetailsDelete = (deleteData: any) => {
	const data = {
		DeletePurposeOfLoanTypeDetailsToken: deleteData,
	};
	const url = `${API_URL}deletePurposeOfLoanTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE PURPOSE OF LOAN TYPE DETAILS END *********************** */

/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS START *********************** */
export const purposeofLoanTypeDetailsFetch = (fetchData: any) => {
	const data = {
		FetchPurposeOfLoanTypeDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchPurposeOfLoanTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PURPOSE OF LOAN TYPE DETAILS END *********************** */

/** ***************** UPDATE PURPOSE OF LOAN DETAILS START *********************** */
export const purposeofLoanTypeDetailsUpdate = (updateData: any) => {
	const data = {
		UpdatePurposeOfLoanTypeDetailsToken: updateData,
	};
	const url = `${API_URL}updatePurposeOfLoanTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE PURPOSE OF LOAN DETAILS END *********************** */
